module.exports = __webpack_public_path__ + "img/comfortaa-v27-latin-500.41d9853f.svg";